import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class CardVariantPicker extends HTMLElement {
  #variants = [];

  connectedCallback() {
    this.#variants = this.#parseVariants();
    this.addEventListener('change', this.#onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onVariantChange);
  }

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  get #formId() {
    return this.getAttribute('data-form-id');
  }

  get #associatedForm() {
    return document.getElementById(this.#formId);
  }

  get #variantIdInput() {
    return this.#associatedForm?.querySelector('[name="id"]');
  }

  get #selectedRadio() {
    return this.querySelector(`input[name="ProductCardVariant-${this.#productId}"]:checked`);
  }

  #parseVariants() {
    try {
      const json = this.querySelector('script[type="application/json"]')?.textContent;
      return json ? JSON.parse(json) : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  #findVariant(id) {
    return this.#variants.find((variant) => variant.id === Number(id)) ?? null;
  }

  #onVariantChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const variant = this.#findVariant(input.value);

    this.#updateVariantIdInput(variant);
    this.#dispatchVariantUpdate(variant);
  };

  /**
   * Updates the hidden variant id input in the associated form.
   * @param {object|null} variant
   */
  #updateVariantIdInput(variant) {
    const input = this.#variantIdInput;
    if (!input) return;

    input.value = variant?.id ?? '';
  }

  /**
   * Dispatches a variant update event on this element.
   * @param {object|null} variant
   */
  #dispatchVariantUpdate(variant) {
    this.dispatchEvent(
      new VariantUpdateEvent(variant, this.id, {
        html: null,
        productId: this.#productId,
        source: 'card-product-variant-picker',
      })
    );
  }
}

if (!customElements.get('card-variant-picker')) {
  customElements.define('card-variant-picker', CardVariantPicker);
}
